export default __webpack_public_path__ + "static/media/image@3x.e0eef1dc.jpg";